module.exports = __webpack_public_path__ + "img/jackaloons.e34eb963.jpg";